module.exports = __webpack_public_path__ + "media/images/ui__textArrowDown-69dc843659d06bf7b11fcd07f1c4b294.png";